(function () {
  document.addEventListener('click', function (e) {
    const swatch = e.target.closest('color-swatch[data-swatch-container]');
    if (!swatch) return;

    const colorValue = swatch.getAttribute('data-value');

    const pdpEl = document.querySelector('[data-pdp-app]');
    if (!pdpEl) return;

    let productData;
    try {
      productData = JSON.parse(pdpEl.getAttribute('data-pdp-app'));
    } catch (err) { return; }

    const variant = productData.variants && productData.variants.find(function (v) {
      return (v.options ? v.options[0] : v.option1) === colorValue && v.featured_image;
    });
    if (!variant) return;

    const targetFilename = variant.featured_image.src.split('/').pop().split('?')[0];

    setTimeout(function () {
      const slides = document.querySelectorAll('.ImageGallery__sliderMobile .swiper-slide:not(.swiper-slide-duplicate)');
      let targetIndex = -1;
      slides.forEach(function (slide, i) {
        const img = slide.querySelector('img');
        if (img && img.src.includes(targetFilename) && targetIndex === -1) targetIndex = i;
      });

      const container = document.querySelector('.ImageGallery__sliderMobile .swiper-container');
      if (container && container.swiper && targetIndex !== -1) {
        // Use slideToLoop for loop mode, fallback to slideTo
        if (container.swiper.params.loop) {
          container.swiper.slideToLoop(targetIndex);
        } else {
          container.swiper.slideTo(targetIndex);
        }
      }
    }, 300);

  }, true);
})();
